module.exports = __webpack_public_path__ + "img/bannerSign.798e8666.png";